import { CSSProgressiveCaption01 } from "@caisy/league";
import styled from "styled-components";

export const SSelectOrganizationStepListItemAlias = styled.div`
  ${CSSProgressiveCaption01};
  color: var(--text-03);
`;
